// Copyright ©️ 2026 eVolve MEP, LLC

import { useEffect } from 'react';

import { useEvolvePaginatedGet } from '@evolvemep/api-ts';

import type { GlobalFilterProps } from 'components/Mantine/GlobalFilters/types';
import { SearchableMultiSelect } from 'components/Mantine/TypeSafeSelect/PaginatedSelectors/SearchableMultiSelect';
import { hasLengthExactly } from 'helpers/helper-types';
import { isNil, isNotNil } from 'helpers/isNotNil';

export const WorkCellsFilter = ({ filter, value, onChange, defaultParams }: GlobalFilterProps<'workCells'>) => {
  const { setDefaultOpts: setDefaultOptsWorkCells, ...paginatedGetWorkCells } = useEvolvePaginatedGet('shop/workCell');

  useEffect(() => {
    if (isNotNil(defaultParams.facilityIds) && hasLengthExactly(defaultParams.facilityIds, 1)) {
      setDefaultOptsWorkCells({
        defaultConfig: {
          params: {
            facilityId: defaultParams.facilityIds[0],
          },
        },
      });
    }
  }, [defaultParams.facilityIds, setDefaultOptsWorkCells]);

  if (!filter || isNil(defaultParams.facilityIds) || !hasLengthExactly(defaultParams.facilityIds, 1)) return null;

  return (
    <SearchableMultiSelect
      paginatedGet={paginatedGetWorkCells}
      onChange={onChange}
      value={value}
      getItemLabel={(w) => w.workCellName}
      idKey="workCellId"
      label="Work Cells"
      placeholder="All Work Cells"
      comboboxProps={{ withinPortal: false }}
      preloadData
      clearable
    />
  );
};
